module.exports = __webpack_public_path__ + "static/media/wordpress.a1c38601.svg";